import { createAsyncThunk } from '@reduxjs/toolkit';

import { getResyncDetails, getSyncStatuses } from 'actions/entityPipelineActions';
import { RootState } from 'store/types';

export const resyncEntityStatusUpdateThunk = createAsyncThunk<
  void,
  {
    payload: {
      entityId: string;
      status: string;
    };
  },
  { state: RootState }
>('RESYNC_ENTITY_STATUS_UPDATE', (action, { dispatch }) => {
  const { entityId } = action.payload;

  // Refetch resync details and pipeline sync statuses so all views (e.g. the
  // pipeline details grid) reflect the current RESYNCING state without needing
  // a page navigation to trigger a fresh getSyncStatuses call.
  dispatch(getResyncDetails(entityId));
  dispatch(getSyncStatuses());
});
